import { IItemDelta } from '../../value-object/ItemDeltaInputVO'
import { UserBasic } from '../../value-object/UserBasicVO'
import { WbsItemType } from '../WbsItemEntity'

export type MilestoneStatus = 'achieved' | 'overdue' | 'pending'

export const DEFAULT_MILESTONE_ICON = 'mdi:rhombus'
export const DEFAULT_MILESTONE_COLOR = '#000000'

/**
 * マイルストーンの対象(wbsItemUuid)に指定できるWBS項目の種別。
 * サーバ側の検証(CreateMilestone/UpdateMilestoneDelta)と揃えている。
 */
export const MILESTONE_TARGET_WBS_ITEM_TYPES = [
  WbsItemType.WORKGROUP,
  WbsItemType.PROCESS,
]

export interface MilestoneDetail {
  uuid: string
  projectUuid: string
  wbsItemUuid?: string
  name: string
  description?: string
  milestoneDate: string
  iconName?: string
  color?: string
  achieved: boolean
  achievedAt?: number
  lockVersion: number
  revision: string
  createdAt: number
  createdBy: UserBasic
  updatedAt: number
  updatedBy: UserBasic
}

export interface MilestoneInput {
  uuid: string
  wbsItemUuid?: string
  name: string
  description?: string
  milestoneDate: string
  iconName?: string
  color?: string
  achieved?: boolean
}

export interface MilestoneDeltaInput {
  uuid: string
  lockVersion: number
  wbsItemUuid?: IItemDelta<string | undefined>
  name?: IItemDelta<string>
  description?: IItemDelta<string | undefined>
  milestoneDate?: IItemDelta<string>
  iconName?: IItemDelta<string | undefined>
  color?: IItemDelta<string | undefined>
  achieved?: IItemDelta<boolean>
}

export interface MilestoneDeleteInput {
  uuid: string
  lockVersion: number
}

export interface MilestoneBatchDeltaInput {
  added: MilestoneInput[]
  edited: MilestoneDeltaInput[]
  deleted: MilestoneDeleteInput[]
}

/**
 * ガント上でのマイルストーンの表示先。
 * rootMilestones はガントヘッダー(表示中ツリーのルート自身)に、
 * descendantMilestonesByWbsItemUuid は各行のガントバー上に描画される。
 */
export type MilestoneScope = {
  rootMilestones: MilestoneDetail[]
  descendantMilestonesByWbsItemUuid: Map<string, MilestoneDetail[]>
}

export const getMilestoneStatus = (
  milestone: Pick<MilestoneDetail, 'achieved' | 'milestoneDate'>
): MilestoneStatus => {
  if (milestone.achieved) return 'achieved'
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const milestoneDate = new Date(milestone.milestoneDate)
  if (milestoneDate < today) return 'overdue'
  return 'pending'
}
